import React from 'react';
export function SocialProofBar() {
  return <div className="bg-brand-cardAlt text-brand-text py-3 px-4 border-y border-black/5" data-id="element-185">
      <div className="max-w-4xl mx-auto text-xs md:text-sm font-semibold text-center" data-id="element-186">
        +2.500 docentes ya tienen su Kit · 6 tomos premium · 4,9/5 ⭐ · Acceso
        inmediato
      </div>
    </div>;
}